import AnalyticsAbstract from "@MAIN/modules/Analytics/Abstract";

export default class Facebook extends AnalyticsAbstract {
  constructor() {
    super()

    if (window.fbq) return;
    const n = window.fbq = function () {
      n.callMethod ?
        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];

    // disabled
    return
    if (process.env.MIX_FACEBOOK_PIXEL) {
      !function (b, e, v) {
        let t = b.createElement(e);
        t.async = !0;
        t.src = v;
        let s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
      }(document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

      window.fbq('init', process.env.MIX_FACEBOOK_PIXEL)
      window.fbq('track', 'PageView')
    }
  }

  Purchase(order) {
    this.log('[FB] Purchase')

    window.fbq('track', 'Purchase', {
      value: order.total_price,
      currency: 'RUB',
      contents: order.items.map(it => ({
        id: it.id,
        amount: it.quantity,
      })),
      content_type: 'product',
    });
  }

  InitiateCheckout() {
    this.log('[FB] InitiateCheckout')
    window.fbq('track', 'InitiateCheckout');
  }

  CompleteRegistration(value) {
    this.log('[FB] CompleteRegistration')
    window.fbq('track', 'CompleteRegistration', {
      value,
      currency : 'RUB'
    });
  }

  Search(search_string) {
    this.log('[FB] Search')
    window.fbq('track', 'Search', {
      search_string
    });
  }

  AddToWishlist() {
    this.log('[FB] AddToWishlist')
    window.fbq('track', 'AddToWishlist');
  }

  TrackLead() {
    this.log('[FB] TrackLead')
    window.fbq('track', 'TrackLead');
  }

  addToCart({id, name, price}) {
    this.log('[FB] addToCart')

    const params = {
      content_type: 'product',
      content_name: name,
      content_ids: [id],
      value: price,
      currency: 'RUB'
    }

    window.fbq('track', 'AddToCart', params);
  }

  ViewContent(product) {
    this.log('[FB] ViewContent')

    const params = {
      content_type: 'product',
      content_ids: [product.id],
      content_name: product.name,
      value: product.price,
      currency: 'RUB'
    }

    window.fbq('track', 'ViewContent', params);
  }
}
